<mat-icon class="form-warning__icon">{{ iconName }}</mat-icon>
<span class="form-warning__text"><ng-content></ng-content></span>
